export function flickr() {
    let ub = 5,
        perPage = 30,
        apiUrl = () => `https://api.flickr.com/services/rest/?method=flickr.interestingness.getList&api_key=b349c4870ef592bcb66e39a997645a9b&format=json&nojsoncallback=1&per_page=${perPage}&page=${getRandomInt(ub)}&extras=owner_name`,
        photoUrl = ({ farm, server, id, secret }) => `https://farm${farm}.staticflickr.com/${server}/${id}_${secret}_b.jpg`,
        adapt = p => {
            return {
                url: photoUrl(p),
                title: p.title,
                author: p.ownername,
                link: `https://www.flickr.com/photos/${p.ownername}/${p.id}/`.replace(' ', '')
            }
        }

    return {
        fetch: createFetch(apiUrl, data => {
            ub = data.photos.pages - 1;
            return data.photos.photo.map(adapt);
        })
    }
}

export function pexels() {
    let ub = 5,
        perPage = 30,
        apiUrl = () => `https://api.pexels.com/v1/search?query=HD+wallpaper&per_page=${perPage}&page=${getRandomInt(ub, 1)}`,
        adapt = p => {
            return {
                url: p.src.large2x,
                title: null,
                author: p.photographer + ' provided by Pexels',
                link: p.url
            }
        };

    return {
        fetch: createFetch(apiUrl, data => {
                ub = Math.floor((data.total_results / perPage)) - 1;
                return data.photos.map(adapt);
            },
            { Authorization: '563492ad6f9170000100000160e6632c359c40ac95d0baa76ec59de9' }
        )
    }
}

export function pixabay() {
    let ub = 5,
        perPage = 30, // min 3 -> api requirement
        apiUrl = () => `https://pixabay.com/api/?key=8553434-1c384dc24960b57b19ec457d7&image_type=photo&orientation=horizontal&editors_choice=true&safesearch=true&per_page=${perPage}&page=${getRandomInt(ub, 1)}`,
        adapt = p => {
            return {
                url: p.webformatURL.replace('_640.', '_960.'),
                title: null,
                author: p.user,
                link: p.pageURL
            }
        };

    return {
        fetch: createFetch(apiUrl, data => {
            ub = Math.floor((data.totalHits / perPage)) - 1;
            return data.hits.map(adapt);
        })
    }
}

// creates the fetch function for a provider
function createFetch(apiUrl, processData, headers) {
    return () => {
        return new Promise((resolve, reject) => {
            fetch(apiUrl(), { headers: headers })
                .then(resp => resp.json(), reject)
                .then(data => resolve(processData(data)), reject)
        });
    }
}

function getRandomInt(max, min=0) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
